
/**
 * Module B
 */
define('b',[],function () {
    var name = 'b';
    return {
        name: name
    };
});
